import styled from '@emotion/styled'
import { Spinner } from 'react-bootstrap'

interface LoaderProps {
    dataTestId?: string
}

const Loader = ({ dataTestId = 'loader' }: LoaderProps) => {
    return <CustomLoader animation="border" data-testid={dataTestId} />
}

const CustomLoader = styled(Spinner)`
    position: relative;
    color: var(--primary-color);
    width: 100px;
    height: 100px;
    border-width: 10px;
    margin: auto;
`

export default Loader
